import React,{Component} from "react"
import emailjs from '@emailjs/browser';

class ContactComponent extends Component{
    constructor(){
        super()
        this.state={
            name:"",
            email:"",
            message:"",
            isValid:true
        }
    }
    inputRef=React.createRef()
    sendEmail = (e) => {
        e.preventDefault();
        const email=this.state.email.split("@")
        const format = /[!1234567890@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/

        if (format.test(this.state.name) || email.length <2 ||this.state.message.length==0){
            this.setState({isValid:false})
            }
        else{
            this.setState({isValid:true})
            emailjs.sendForm('service_2frgzye', 'template_1skw5ac', this.inputRef.current, 'Dm6iCdNTVJVp3Dk4u')
                .then((result) => {
                    const succ =document.querySelector(".toastSuccess")
                  succ.style.visibility="visible"
                  setTimeout(()=>{
                      succ.style.visibility="hidden"
                  },5000);
                }, (error) => {
                    console.log(error.text);
                    const fail =document.querySelector(".toastFailure")
                    fail.style.visibility="visible"
                    setTimeout(()=>{
                        fail.style.visibility="hidden"
                    },5000);
                });
            }
      };
    handleChange=(event)=>{
        this.setState({[event.target.name]:event.target.value})
    }
    // checkValidation=(event)=>{}
       
    render(){
        return(
            <>
            <div className="contact">
                <div className="contactImage">
                    <img src="./contact.png" />
                </div>
                <form ref={this.inputRef} onSubmit={this.sendEmail} className="form">
                <h1 style={{textAlign:"center"}}>Contact Me!</h1>
                    <input onChange={this.handleChange} name="name"className="formElements" type="text" placeholder="Name" value={this.state.name}></input>
                    {this.state.isValid?"":<p className="validError">*Name cannot contain special characters and numerals</p>}
                    
                    <input onChange={this.handleChange} name="email"className="formElements" type="text" placeholder="Email" value={this.state.email}></input>
                    {this.state.isValid?"":  <p className="validError"> *Please enter a valid email</p>}
                   
                    <textarea onChange={this.handleChange} style={{border:"2px solid white",borderRadius:"5px",resize:"none"}} name="message" className="formElements" placeholder="Write Here!" value={this.state.message} rows="10"></textarea>
                    {this.state.isValid?"":  <p className="validError"> *Message cannot be empty!</p>}
                    
                    <button className="btn" type="submit">Submit</button>
                </form>
            </div>
            <span className="toastSuccess">	&#10003; Message Sent!</span>
            <span className="toastFailure">	Something went wrong! </span>
            
            
            </>
        )
    }
}

export default ContactComponent;